/**
 * @param {Object} storeState - Redux root state
 * @returns {Object} Props for DeprecateOrgModal
 */
export default function selector(storeState) {
    const modalState = storeState?.deprecateOrgModal ?? {};
    return {
        isOpen: modalState.isOpen,
        isDeprecating: modalState.isDeprecating,
        // Full org snapshotted at open — component extracts name / client_type for copy
        organization: modalState.organization ?? null,
        userCount: modalState.userCount ?? 0,
    };
}
